<template>
  <div :id="outerId" class="clearfix" :style="{ minHeight: minHeight + 'px', width: '100%' }">
    <div :id="chartId" :style="{ minHeight: minHeight + 'px', width: '100%' }">

    </div>
  </div>
</template>
<script>
  import ChartMixin from './mixins/chart'
  export default {
    name: 'SimpleLayeredBar',
    mixins: [ChartMixin],
    props: {
      chartData: {
        /*
        * Data must be in the structure: {
        * categoryField: 'val',
        * valueField: 'val',
        * }
        * where categoryField will equal this.props.categoryField --> x axis
        * where valueField will equal this.props.valueField --> y axis
        */
        type: Array,
        required: true
      },
      categoryField: {
        type: String,
        required: true
      },
      rotate: {
        type: Boolean,
        required: false,
        default: false
      },
      cluster: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    methods: {
      init (data) {
        let graphs = []
        this.chartData.forEach(obj => {
          let count = 0
          for (let prop in obj) {
            if (prop !== this.categoryField) {
              let g = {
                balloonText: `${prop} - [[value]]`,
                fillAlphas: 0.8,
                lineAlpha: 0.2,
                title: prop,
                type: 'column',
                valueField: prop,
                clustered: this.cluster
              }
              if (!this.cluster) {
                count++
                g.columnWidth = (10 - count) / 10
              }
              graphs.push(g)
            }
          }
        })
        this.chart = window.AmCharts.makeChart(this.chartId, {
          type: 'serial',
          theme: 'light',
          categoryField: this.categoryField,
          rotate: this.rotate,
          startDuration: 1,
          plotAreaFillAlphas: 0.1,
          categoryAxis: {
            gridPosition: 'start'
          },
          graphs: graphs,
          valueAxes: [
            {
              id: 'ValueAxis-1',
              position: 'top',
              axisAlpha: 0
            }
          ],
          dataProvider: this.chartData,
          export: {
            enabled: true
          }
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// SimpleLayeredBar.vue?bb94a63a